import React, { useState } from 'react';

import { Route, Switch } from 'react-router-dom';

import {
  innerWrapperStyle,
  cardsStyle,
	titleStyle,
	textStyle,
	ctaStyle,
	videoSection,
	videoDiv,
} from 'inside-out/page-styles/medicare';

import { ColouredCard } from 'inside-out/components/shared/cards/colouredCard';
import { ResourceCard } from 'inside-out/components/shared/cards/resourceCard';

import FAQImg from 'inside-out/images/medicare/faq.png';

import {
  orange,
  tabletPortraitMaxWidthBreakpoint,
	contentSection
} from 'inside-out/global-styles'

import { MedicareForMeStep1Page } from 'inside-out/components/medicare/for-me/step-1'
import { MedicareForMeStep2Page } from 'inside-out/components/medicare/for-me/step-2'
import { MedicareForMeStep3Page } from 'inside-out/components/medicare/for-me/step-3'
import { MedicareForMeStep4Page } from 'inside-out/components/medicare/for-me/step-4'
import { MedicareForMeStep5Page } from 'inside-out/components/medicare/for-me/step-5'

import { StepSelect } from 'inside-out/components/medicare/stepSelect'

function MedicareForMePage() {
  const [ step, setStep ] = useState(0)

  return (<React.Fragment>
		<section className={contentSection('#fff')}>
			<div className={innerWrapperStyle}>
				<header>
					<h1 className={titleStyle} style={{color: orange}} id="level-2">Medicare for you</h1>
				</header>
				<div className={textStyle}>
					<h2>Am I eligible?</h2>
					<p>You are eligible if you have a clinical diagnosis of Anorexia Nervosa. If you have a diagnosis of Bulimia Nervosa, Binge Eating Disorder, or Other Specified Feeding and Eating Disorders your GP will assess a couple of extra eligibility criteria. These include an assessment on the Eating Disorders Examination Questionnaire (EDE-Q) and criteria relating to medical and mental health severity.</p>
					<p>Even if you do not meet the criteria for these items, you may still be able to access treatment under the existing Better Access to Mental Health scheme.  Please discuss your eligibility and referral options with your GP.</p> 
					<p>The Eligibility Criteria for these items has been updated on the Federal Register of Legislation, you can read it in full <a target="_blank" rel="noopener noreferrer" href="https://www.legislation.gov.au/Details/F2019L01318">here</a>.</p>

          <p><a href="/medicare/faq"><img src={ FAQImg } alt="FAQ link" /></a></p>

				</div>
			</div>
		</section>

		<section className={videoSection(orange)}>
			<div className={videoDiv}>
				<div>How does it work?</div>

				<iframe src="https://player.vimeo.com/video/369493029" width="640" height="360" frameBorder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>

        <div style={{width: '250px', position: 'absolute' }}>
          <ResourceCard
            key={0}
            background={ null }
            to={ '/resource-library/navigating-eating-disorders' }
            audiences={ [] }
            title={ 'Medicare Items Summary' }
            body={ 'A one-page summary of the process for accessing treatment under the Eating Disorder Plan' }
            date={ '1 Nov, 2019' }
          />
        </div>
			</div>
		</section>

    <StepSelect step={ step } setStep={ setStep } color={ orange }/>

    { (step === 1) && <MedicareForMeStep1Page /> }
    { (step === 2) && <MedicareForMeStep2Page /> }
    { (step === 3) && <MedicareForMeStep3Page /> }
    { (step === 4) && <MedicareForMeStep4Page /> }
    { (step === 5) && <MedicareForMeStep5Page /> }

  </React.Fragment>);
}

export default MedicareForMePage



// WEBPACK FOOTER //
// ./src/pages/medicare/for-me/index.js